import React from "react";
import SalesTeamForm from "./SalesTeamForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const CreateSalesTeam = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <SalesTeamForm />
  </DashboardLayout>
);

export default CreateSalesTeam;
